import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  image_url: string;
  title: string;
  field_cards_title_ms: string;
  field_cards_title_zh: string;
  field_cards_desc_en: string;
  field_cards_desc_ms: string;
  field_cards_desc_zh: string;
  field_cards_url_en: string;
  field_cards_url_ms: string;
  field_cards_url_zh: string;
  field_cards_image: string;
  field_cards_sequence: number;
  sequence: number;
  published: boolean;
  created_at: string;
  updated_at: string;
}

// edit api call
const fetchSmallCardsDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await corporateCMSApi.get(`/api/get-homepage-cards-id/${id}`);
  return response.data[0];
};

const useSmallCardsDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["smallcardsDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchSmallCardsDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useSmallCardsDocumentDetails };
